const http_config = {
    api_base_url: 'http://api2.guoguohaoa.com/',
    access_token: "8153fdfd600a0694301d0ac885c393b9"
}
export { http_config }
